export default __webpack_public_path__ + "static/media/doc-xls.fbc7ed14.svg";